import MessagesMainBox from "./MessagesMainBox"
import ButtonBar from '../../Elements/ButtonBar'

const menu_bar = [
  {
    title: 'Mensajes',
    buttons: [
      // {
      //   label: 'Categorias',
      //   color: 'green',
      //   onClick: () => {
      //     // Handle button click logic for "Crear Socio"
      //   },
      // },
      {
        label: 'Crear Mensaje',
        color: 'green',
        onClick: () => {
          // Handle button click logic for "Borrar"
        },
      },
      {
        label: 'Borrar',
        color: 'red',
        onClick: () => {
          // Handle button click logic for "Actualizar"
        },
      },
      {
        label: 'Actualizar',
        color: 'yellow',
        onClick: () => {
          // Handle button click logic for "Actualizar"
        },
      },

    ],
  },
];


export default function Messages() {
  return (
    <div className='flex flex-col gap-4'>
        {menu_bar.map((menuItem, index) => (
        <ButtonBar
          key={index}
          title={menuItem.title}
          buttons={menuItem.buttons}
        />
      ))}
        <div className="flex flex-row gap-4 w-full">
            <MessagesMainBox />

            
        </div>
    </div>
  )
}
